import { Button } from "@/components/flexkit/Button";
import { Input } from "@/components/podkit/forms/Input";
import type { PropsWithClassName } from "@/components/podkit/lib/cn";
import { cn } from "@/components/podkit/lib/cn";
import { useTemporaryState } from "@/hooks/use-temporary-value";
import { Eye, EyeOff } from "lucide-react";
import { forwardRef, useCallback } from "react";
type PasswordInputProps = React.ComponentPropsWithoutRef<"input"> & {
    revealable?: boolean;
} & PropsWithClassName;
const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(({ revealable, ...props }, ref) => {
    const [reveal, setReveal] = useTemporaryState(false, 5000);

    const toggleType = useCallback(() => {
        setReveal(!reveal);
    }, [reveal, setReveal]);

    return (
        <div className="relative">
            <Input
                className={cn("ring-inset", revealable ? "pr-12" : "")}
                {...props}
                type={reveal ? "text" : "password"}
                ref={ref}
            />
            {revealable && (
                <div className={cn("absolute inset-y-0 right-2 flex items-center", { hidden: !props.value })}>
                    <Button
                        variant={"ghost"}
                        type="button"
                        className="h-6 rounded-lg border-none p-1 text-content-tertiary hover:text-content-secondary hover:opacity-100"
                        onClick={toggleType}
                        aria-label="Reveal password"
                    >
                        {reveal ? <EyeOff className="text-red-500" size={16} /> : <Eye size={16} />}
                    </Button>
                </div>
            )}
        </div>
    );
});
PasswordInput.displayName = "PasswordInput";

export { PasswordInput };
